/* ============
 * Bill Product Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeIngredience/state.js